import { render } from "./ManualEdit.vue?vue&type=template&id=c4167592&scoped=true"
import script from "./ManualEdit.vue?vue&type=script&lang=js"
export * from "./ManualEdit.vue?vue&type=script&lang=js"

import "./ManualEdit.vue?vue&type=style&index=0&id=c4167592&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4167592"]])

export default __exports__